import { type DevicesByStatuses, type IncidentCountBySeverity, SpaceType } from '@api/locations';
import type { EntityStatus } from '@core';

export { SpaceType };

export interface Space {
  createdOn: string;
  devicesByStatuses: DevicesByStatuses;
  devicesCount: number;
  documentReference: string;
  externalReference: string;
  friendlyName: string;
  id: string;
  incidentCountBySeverity: IncidentCountBySeverity;
  locationId: string;
  name: string;
  parentSpace?: Space;
  parentSpaceId: string | null;
  position?: number;
  status: EntityStatus;
  type: SpaceType;
  unstructuredDataReference: string;
}

export interface FloorSpaceModel extends Space {
  floorplan?: string;
  rooms?: RoomSpaceModel[];
  type: typeof SpaceType.FLOOR;
}

export interface RoomSpaceModel extends Space {
  type: typeof SpaceType.ROOM;
}
